import { defineStore } from 'pinia'
import type { Product, VariantColor } from '~/types/product.type'

export const useProductDetailStore = defineStore('productDetail', () => {
  const product = ref<Product | null>(null)

  const { t } = useI18n()

  function getProductDetail(id: string) {
    return useApi<Product>(`/api/products/${id}`, {
      method: 'GET',
      watch: false,
      key: `product-${id}`,
      onResponse({ response }) {
        if (response.ok)
          product.value = response._data
        else
          throw new Error('Failed to fetch product')
      },
    })
  }

  const possibleColors = computed(() => {
    const colorList: VariantColor[] = product.value?.variants?.map(
      (x) => {
        if (x.color === null)
          return { title: t('color.no_color'), code: null }

        return x.color ?? null
      },
    ) ?? []
    return [...new Set(colorList.map(x => JSON.stringify(x)))]
      .map(x => JSON.parse(x) as VariantColor)
      .sort((a, b) =>
        a.title.localeCompare(b.title),
      )
  })

  return {
    product,
    getProductDetail,
    possibleColors,
  }
})
